<template lang="pug">
  v-card.card-sw.mt-6.elevation-0(
    :class="{'margin-sw': stepWork.isMargin && !isCarousel && !isMdCarousel}"
    :ripple="false"
    @click="changeSlide")
    v-row.ma-0
      v-avatar.avatar-sw
        span.span-sw(:class="{'white--text': isDisabled && !isCarusel, 'black--text': !isDisabled || isCarusel}"
          ) {{ stepWork.numberStep }}
      font-awesome-icon.icon-sw(v-if="stepWork.numberStep < 4" @click.stop='drawer = !drawer' :icon="['fa', 'arrow-right']")
    v-progress-linear.mt-5.mr-3(
      v-model="value"
      color="black"
      height="2"
      buffer-value="100"
      )
    p.header-text-sw(:class="{'opacity-sw': isDisabled && !isCarusel}") {{ stepWork.headerText }}
    p.body-text-sw(:class="{'opacity-sw': isDisabled && !isCarusel}") {{stepWork.bodyText}}
</template>

<script>
export default {
  name: "StepWork",
  props: {
    stepWork: {
      type: Object,
      default: () => {}
    },
    isRestart: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    startSlide: {
      type: Number,
      default: () => 0
    },
    numberStepNow: {
      type: Number,
      default: () => 0
    },
    isCarousel: {
      type: Boolean,
      default: () => false
    },
    isMdCarousel: {
      type: Boolean,
      default: () => false
    },
    isVisible: {
      type: Boolean,
      default: () => false
    },
  },
  data () {
    return {
      ENDSTEPS: 4,
      interval: {},
      intervalCarusel: {},
      value: 0,
      cont: true
    }
  },
  watch: {
    startSlide: {
      immediate: true,
      deep: true,
      handler () {
        if (this.isCarusel) {
          this.intervalCarusel = setInterval(() => {
            if (this.isCarusel) {
              if (this.value === 100) {
                this.$emit('onEndStepCarusel', this.stepWork.numberStep)
                return (this.value = 0)
              }
              this.value += 2
            } else {
              this.value = 0
            }
          }, 80)
        } else {
          clearInterval(this.intervalCarusel)
        }
      }
    },
    isDisabled: {
      immediate: true,
      deep: true,
      handler () {
        if (this.isVisible) {
          this.runIntrval()
        }
      }
    },
    isRestart: {
      immediate: true,
      deep: true,
      handler () {
        this.value = 0
      }
    },
    isVisible: {
      immediate: true,
      deep: true,
      handler () {
        if (!this.isVisible ) {
          clearInterval(this.interval)
          this.cont = true
        } else {
          if ((this.numberStepNow === this.stepWork.numberStep) && this.cont) {
            this.runIntrval()
            this.cont = false
          }
        }
      }
    },
    numberStepNow: {
      immediate: true,
      deep: true,
      handler () {
        if (this.isDisabled) {
          this.value = this.numberStepNow < this.stepWork.numberStep ? 0 : 100
        }
        if (this.isCarusel) {
          this.value = 0
        }
      }
    }
  },
  computed: {
    isCarusel () {
      return (this.stepWork.numberStep === this.startSlide)
    }
  },
  methods: {
    runIntrval (){
      if (!this.isDisabled && !this.isCarusel) {
        this.interval = setInterval(() => {
          if (!this.isDisabled && !this.isCarusel) {
            if (this.value === 100) {
              this.$emit('onEndStep', this.stepWork.numberStep)
              return (this.value = 100)
            }
            this.value += 2
          }
        }, 80)
      } else {
        clearInterval(this.interval)
      }
    },
    changeSlide() {
      this.value = 0
      this.$emit('onEndStep', this.stepWork.numberStep, true)
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "scss/variables.scss"
  @import "scss/colors.scss"

  @media(max-width: $mdAndDown)
    .header-text-sw
      font-size: max(calc(9px + 1.7vw), 24px)
      margin-top: 18px
      margin-bottom: 0

    .body-text-sw
      line-height: 22px
      font-size: max(calc(3px + 1.3vw), 16px)
      margin-top: 12px

    .header-text-sw
      height: 50px !important

  @media(min-width: 1150px) and (max-width: $mdOnlyEnd)
    .body-text-sw
      line-height: 25px !important

  @media(min-width: $lgOnlyStart) and (max-width: 1400px)
    .body-text-sw
      line-height: 25px !important

  @media(min-width: $lgAndUp)
    .card-sw
      max-width: 305px
      width: 100%

    .header-text-sw
      margin-top: 20px
      margin-bottom: 16px
      font-size: min(calc(8px + 1.1vw), 30px)

    .body-text-sw
      line-height: 30px
      margin-top: 8px
      font-size: min(calc(7px + 0.9vw), 21px)

  @media(min-width: $xl)
    .body-text-sw
      font-size: 24px

    .header-text-sw
      font-size: 30px

  //.hide-progress
  //  display: none

  .card-sw
    background: transparent !important

  .v-card--link::before
    opacity: 0 !important

  .icon-sw
    margin-top: 13px
    font-size: 24px
    margin-left: auto

  .avatar-sw
    font-size: 30px
    background: $avatarColor

  .span-sw
    font-size: 30px
    font-weight: 500
    font-family: RobotoRegular

  .header-text-sw
    height: 60px
    line-height: 25px
    font-family: GothamProMedium

  .body-text-sw
    font-family: GothamProClassic

  .boby-text-carusel
    line-height: 20px !important

  .opacity-sw
    opacity: 0.3

  .margin-sw
    margin-right: 4%

</style>